
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/reports/structure",
      function () {
        return require("private-next-pages/[lang]/reports/structure/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/reports/structure"])
      });
    }
  